import { cn } from '@/lib/utils';

type ArcImageProps = {
  src: string;
  alt: string;
  className?: string;
  width?: number;
  height?: number;
  /** When true, fills positioned parent (parent must be `relative` and sized). */
  fill?: boolean;
  unoptimized?: boolean;
  onError?: React.ReactEventHandler<HTMLImageElement>;
  loading?: 'lazy' | 'eager';
  /** Next.js compatibility — ignored. */
  priority?: boolean;
  /** Next.js compatibility — ignored. */
  sizes?: string;
};

/**
 * Drop-in replacement for common `next/image` usage in this project (no optimizer).
 */
export function ArcImage({
  src,
  alt,
  className,
  width,
  height,
  fill,
  onError,
  loading,
  priority,
  ...rest
}: ArcImageProps) {
  void priority;
  void rest;
  if (fill) {
    return (
      <img
        src={src}
        alt={alt}
        className={cn('absolute inset-0 h-full w-full', className)}
        loading={loading ?? 'lazy'}
        decoding="async"
        onError={onError}
      />
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      loading={loading ?? 'lazy'}
      decoding="async"
      onError={onError}
    />
  );
}
